export class PatchVenueBookingsClosedNoteCommand {
  constructor(date, venueDetailsId, bookingClosed, messageToAdd) {
    this.date = date;
    this.venueDetailsId = venueDetailsId;
    this.bookingClosed = bookingClosed;
    this.messageToAdd = messageToAdd;
  }
}
